import { render, staticRenderFns } from "./SentimentMarketValue.vue?vue&type=template&id=b2cab7c6&scoped=true"
import script from "./SentimentMarketValue.vue?vue&type=script&lang=js"
export * from "./SentimentMarketValue.vue?vue&type=script&lang=js"
import style0 from "./SentimentMarketValue.vue?vue&type=style&index=0&id=b2cab7c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cab7c6",
  null
  
)

export default component.exports